<template>
  <div class="wrapper">
    <div class="cookie-body">
      Cookies使用策略 <br>
      我们的网站使用cookies以改进我们的网站和改善用户体验。<br><br>
      如您继续浏览本网站而未更改浏览器cookie设置，视为同意我们的cookies使用策略。<br><br>

      <span>Cookies政策</span>
      <div style="text-align: center">
        <div class="button clearfix">
          <div class="dont" @click="saveCookie('no')">不同意</div>
          <div class="yes" @click="saveCookie('agree')">同意</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "cookieAgree",
    methods:{
      saveCookie(status){
        localStorage.setCookies = status
        // this.$store.commit('setCookieBox',status)
        this.$emit('setCookies')
      }

    }
  }
</script>

<style scoped lang="scss">
  .wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    background: rgba(0, 0, 0, 0.1);
  }

  .cookie-body {
    width: 600px;
    height: 200px;
    background: #fff;
    left: 0;
    right: 0;
    margin: 100px auto;
    padding: 20px 15px;
    color: #676767;
    position: relative;
  }

  .cookie-body span {
    color: red;
    text-decoration: underline;
  }

  .button {
    display: inline-block;
    margin-top: 10px;

  }

  .button .dont {
    width: 100px;
    height: 30px;
    border-radius: 20px;
    border: 1px solid #676767;
    text-align: center;
    line-height: 30px;
    float: left;
    margin-right: 50px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .yes {
    width: 100px;
    height: 30px;
    border-radius: 20px;
    background: $bg-color;
    color: #fff;
    text-align: center;
    line-height: 30px;
    float: left;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/cookieAgree.vue